import moment from 'moment'
import React from 'react'
import { Form } from 'react-bootstrap'
import SingleDatePicker from '../../common/single-date-picker'

const DateBox = ({
    label,
    value,
    onChange = () => {},
    placeholder,
}) => {

    const onDateChange = React.useCallback(date => {
        onChange(moment(date).format('YYYY-MM-DD'))
    }, [onChange])

    return (
        <Form.Group>
            <SingleDatePicker value={value} onChange={onDateChange} showPastDates label={label} placeholder={placeholder}/>
        </Form.Group>
    )
}

export default DateBox